import { AsbestosPresentStatus, LeadPresentStatus } from "shared/types/building-inspection";
import { API_URL } from "constants/index";
import { fetchWithAuth } from "shared/api/fetch-with-auth";
import { FileLabel, FileLogStatus } from "shared/types/file";
import { BuildingDTO } from "shared/types/building";

export const calculateDangerousMaterialsInfoDotValues = async (building: BuildingDTO, session: any) => {
    let dotValues: any = {
        red: { count: 0, labels: [] },
        orange: { count: 0, labels: [] },
        green: { count: 0, labels: [] },
        transparent: { count: 0, labels: [] },
    };

    if (building.buildingInspectionInfo?.asbestosPresentStatus == AsbestosPresentStatus.OK) {
        dotValues.green.count++;
        dotValues.green.labels.push("Geen asbest aanwezig");
    } else if (building.buildingInspectionInfo?.asbestosPresentStatus == AsbestosPresentStatus.SUSPICION_PRESENT) {
        dotValues.orange.count++;
        dotValues.orange.labels.push("Vermoeden asbest aanwezig");
    } else if (building.buildingInspectionInfo?.asbestosPresentStatus == AsbestosPresentStatus.NOT_OK_LESS_URGENT) {
        dotValues.orange.count++;
        dotValues.orange.labels.push("Asbest aanwezig, te verwijderen bij renovatie");
    } else if (building.buildingInspectionInfo?.asbestosPresentStatus == AsbestosPresentStatus.NOT_OK_URGENT) {
        dotValues.red.count++;
        dotValues.red.labels.push("Asbest aanwezig, dringed te verwijderen");
    } else {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Onbekend of asbest aanwezig is");
    }

    if (building.buildingInspectionInfo?.leadPresentStatus == LeadPresentStatus.OK) {
        dotValues.green.count++;
        dotValues.green.labels.push("Geen loden buizen aanwezig");
    } else if (building.buildingInspectionInfo?.leadPresentStatus == LeadPresentStatus.NOT_OK) {
        dotValues.red.count++;
        dotValues.red.labels.push("Loden buizen aanwezig");
    } else {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Onbekend of loden buizen aanwezig zijn");
    }

    try {
        const queryParams = new URLSearchParams();
        if (building && building.id) {
            queryParams.append('buildingId', building.id);
        }

        const labels = [
            FileLabel.Asbestattest,
        ];
        queryParams.append('labels', labels.join(','));

        const response = await fetchWithAuth(
            `${API_URL}/file/get-file-logs?${queryParams.toString()}`,
            { method: 'GET' },
            session
        );
        const fileLogs = await response.json();
        
        const asbestosCertificateLogs = fileLogs.filter((log: any) =>
            log.label.includes(FileLabel.Asbestattest)
        ).sort((a: any, b: any) => new Date(b.documentDate).getTime() - new Date(a.documentDate).getTime());

        if (!asbestosCertificateLogs.length) {
            dotValues.transparent.count++;
            dotValues.transparent.labels.push("Geen asbestattest aanwezig");
        } else {
            const latestCertificate = asbestosCertificateLogs[0];
            
            if (latestCertificate.status === FileLogStatus.OK) {
                dotValues.green.count++;
                dotValues.green.labels.push("Geldig asbestattest aanwezig");
            } else if (latestCertificate.status === FileLogStatus.OK_WITH_REMARKS) {
                dotValues.orange.count++;
                dotValues.orange.labels.push("Asbestattest aanwezig met opmerkingen");
            } else if (latestCertificate.status === FileLogStatus.NOT_OK) {
                dotValues.red.count++;
                dotValues.red.labels.push("Ongeldig asbestattest");
            } else if (latestCertificate.status === FileLogStatus.NOT_REQUIRED) {
                dotValues.green.count++;
                dotValues.green.labels.push("Asbestattest niet vereist");
            } else {
                dotValues.transparent.count++;
                dotValues.transparent.labels.push("Asbestattest aanwezig, maar status onbekend");
            }
        }
    } catch (error) {
        console.error('Error fetching asbestos certificate logs:', error);
    }

    return dotValues;
};